import React, { FunctionComponent } from 'react';
import { PopupMenuItem, PopupMenuItemIcon, ContanierSocialMenu, ItemSocialMenu, TriangleSocialMenu } from './globalsToolbar';

import SocialFacebook from 'src/shared/svg/socialFacebook';
import SocialLinkedin from 'src/shared/svg/socialLinkedin';
import SocialInstagram from 'src/shared/svg/socialInstagram';
import SocialYouTube from 'src/shared/svg/socialYoutube';

export interface InfoSocialMenu {
    isSocialPopupVisible: boolean;
}

const SocialMenu: FunctionComponent<InfoSocialMenu> = (props) => {
    return (
        <ContanierSocialMenu $isVisible={props.isSocialPopupVisible}>
            <TriangleSocialMenu />

            <ItemSocialMenu>
                <PopupMenuItem href='https://www.facebook.com/zakekeofficial' target='_blank'>
                    <PopupMenuItemIcon>
                        <SocialFacebook />
                    </PopupMenuItemIcon>
                    Facebook
                </PopupMenuItem>

                <PopupMenuItem href='https://www.youtube.com/channel/UCZPd_oA-Hjq6CE4G1vSUM1Q' target='_blank'>
                    <PopupMenuItemIcon>
                        <SocialYouTube />
                    </PopupMenuItemIcon>
                    YouTube
                </PopupMenuItem>

                <PopupMenuItem href='https://www.linkedin.com/company/11087529 ' target='_blank'>
                    <PopupMenuItemIcon>
                        <SocialLinkedin />
                    </PopupMenuItemIcon>
                    Linkedin
                </PopupMenuItem>

                <PopupMenuItem href='https://www.instagram.com/zakeke.official' target='_blank'>
                    <PopupMenuItemIcon>
                        <SocialInstagram />
                    </PopupMenuItemIcon>
                    Instagram
                </PopupMenuItem>

                {/* <LinkContainer  href='https://www.zakeke.com/blog/?utm_source=zakeke&utm_medium=organic&utm_campaign=dashboard' target='_blank' >
              <ContainerIcon>
                <KeySolid/>
              </ContainerIcon>
              Blog
            </LinkContainer> */}
            </ItemSocialMenu>
        </ContanierSocialMenu>
    );
};

export default SocialMenu;
